<div class="flex align-items-center justify-content-center mt-4 mb-8">
    <div style="width: 220px">
        <img width="100%" alt="Logo" src="assets/images/Logo_High_Res.jpg" />
    </div>
</div>

<h1>{{ 'cancel.title' | translate }} - {{deal?.title}}</h1>

@if (step == "one") {
<div class="flex flex-column gap-2">
    <app-deal-products [deal]="deal" />

    <div [formGroup]="form" class="my-6">
        <div class="flex flex-column md:flex-row gap-2 w-full">
            <div class="flex flex-column gap-2 w-full">
                <label for="cancellationReason">{{ 'cancel.cancellationReason' | translate }}</label>

                <p-dropdown id="cancellationReason" formControlName="cancellationReason" [options]="cancellationReasons"
                    optionLabel="display" optionValue="key" [showClear]="false" [filter]="false"
                    [ngClass]="cancellationReason?.invalid && (triedToSubmit || cancellationReason?.dirty || cancellationReason?.touched) ? 'ng-dirty ng-invalid' : ''"
                    [style]="{ width: '400px'}"></p-dropdown>
            </div>
        </div>
    </div>

    <div class="mb-8">
        <p-toolbar>
            <div class="p-toolbar-group-start">
            </div>
            <div class="p-toolbar-group-center">
            </div>
            <div class="p-toolbar-group-end">
                <p-button (click)="cancel()" [label]="translateService.instant('buttons.cancel')"></p-button>
            </div>
        </p-toolbar>
    </div>
</div>
}

@if (step == "two") {
<div class="text-center mt-8">
    <h1>{{ 'cancel.success.title' | translate }}</h1>
    <div>{{ 'cancel.success.message' | translate }}</div>
</div>
}

<p-confirmDialog #cd>
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
            <div
                class="border-circle bg-main text-white inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                <i class="pi pi-question text-5xl"></i>
            </div>
            <span class="font-bold text-2xl block mb-2 mt-4">{{ message.header }}</span>
            <p class="mb-0">{{ message.message }}</p>
            <div class="flex align-items-center gap-2 mt-4">
                <button pButton [label]="translateService.instant('cancel.buttons.cancel')" (click)="cd.reject()"
                    class=""></button>
                <button pButton [label]="translateService.instant('cancel.buttons.ok')" (click)="cd.accept()"
                    class="bg-secondary"></button>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>